<template>
    <div class="container p-4">
        <div class="alert alert-danger">
            <strong><i class="fas fa-exclamation-circle"></i> Erreur</strong> <br>
            Votre enregistrement s'est mal passé !<br> Veuillez ressayer !
        </div>
    </div>
</template>

<script>

export default {
  name: 'Error',
}
</script>
